import { Icon } from '@sakhtar/design-system/react';
import { faInt } from '../format.js';
import type { ConfirmHeavyMessage, HeavyReason } from '../types.js';

export interface ConfirmHeavyCardProps {
  readonly message: ConfirmHeavyMessage;
  readonly onConfirm: (message: ConfirmHeavyMessage) => void;
  readonly onCancel: (message: ConfirmHeavyMessage) => void;
  readonly busy: boolean;
}

const REASON_TEXT: Readonly<Record<HeavyReason, string>> = {
  costing: 'تحلیل سنگین: محاسبهٔ ردیف‌به‌ردیف بهای تمام‌شده روی چند ماژول.',
  modules: 'تحلیل سنگین: بیش از سه ماژول.',
};

/**
 * Frame G - confirm before a heavy analysis. «اجرا» is the only thing that
 * sends the question; the figure is an ESTIMATE and tokens are deducted only
 * after the answer arrives.
 */
export function ConfirmHeavyCard({ message, onConfirm, onCancel, busy }: ConfirmHeavyCardProps) {
  return (
    <div className="sk-card ai-state ai-confirm-card">
      <div className="ai-confirm" data-status={message.status}>
        <div className="ai-confirm__text">
          <span className="ai-confirm__icon" aria-hidden="true">
            <Icon name="shield" size="md" />
          </span>
          <span>
            این تحلیل حدود <span className="sk-num">{faInt(message.estimate)}</span>{' '}
            {message.unit ?? 'توکن'} مصرف می‌کند.
            {message.balance === null ? null : (
              <>
                {' '}
                موجودی: <span className="sk-num">{faInt(message.balance)}</span>{' '}
                {message.unit ?? 'توکن'}.
              </>
            )}
          </span>
        </div>
        {message.status === 'pending' ? (
          <div className="ai-confirm__actions">
            <button
              type="button"
              className="sk-btn sk-btn--primary sk-btn--sm"
              disabled={busy}
              onClick={() => onConfirm(message)}
            >
              اجرا
            </button>
            <button
              type="button"
              className="sk-btn sk-btn--secondary sk-btn--sm"
              disabled={busy}
              onClick={() => onCancel(message)}
            >
              لغو
            </button>
          </div>
        ) : (
          <div className="ai-confirm__result" role="status">
            {message.status === 'confirmed' ? 'اجرا تأیید شد.' : 'لغو شد؛ توکنی کسر نشد.'}
          </div>
        )}
      </div>
      <div className="ai-state__note">
        {message.note ??
          `${REASON_TEXT[message.reason]} این عدد برآورد است؛ مصرف واقعی پس از پاسخ ثبت می‌شود.`}
      </div>
    </div>
  );
}
